import React from 'react';
import ReactDOM from 'react-dom';

import { getApolloClient } from '@confluence/graphql';
import { Pendo } from '@confluence/pendo';
import { getSessionData, getEmptySessionData } from '@confluence/session-data';
import { ThemeContainer } from '@confluence/theming/entry-points/ThemeContainer';
import { RoutesContext } from '@confluence/route-manager/entry-points/RoutesContext';
import { loadTranslation } from '@confluence/i18n';
import { BrowserNotSupportedLoader as BrowserNotSupportedPage } from '@confluence/browser-not-supported/entry-points/BrowserNotSupportedLoader';
import { initializePreloaderFnContext } from '@confluence/query-preloaders';

import { coreBrowserNotSupported } from '@devtools/browser-check';

import { initialization } from '../../initialization';
import renderComponentIntoDOM from '../StandaloneComponentRenderer/helpers/renderComponentIntoDOM';
import { lazyLanguage } from '../../i18n/lazy-language';
import { postProcessSessionData } from '../../post-process-session-data';

import { hideMainContainer } from './fix-jank-ui';
import StandaloneConfluenceNavigationContainer from './StandaloneConfluenceNavigationContainer';

const sessionDataPromise = (async () => {
	getApolloClient();
	await initializePreloaderFnContext();
	// For the same reasons as in the non-standalone case documented in the
	// counterpart of this file which is
	// confluence/packages/confluence-frontend-server/src/index.js at the moment
	return getSessionData().then(postProcessSessionData, getEmptySessionData);
})();

const translationPromise = loadTranslation(lazyLanguage);

Promise.all([sessionDataPromise, translationPromise]).then(([sessionData]) => {
	const browserNotSupportedCheck = coreBrowserNotSupported();

	// the only requirement for BrowserNotSupported to render is the translationPromise
	if (browserNotSupportedCheck) {
		// the monolith attaches this id to the body here: confluence-core/confluence-webapp/src/main/webapp/decorators/main.vmd:62
		const documentBody = document.getElementById('com-atlassian-confluence');
		// eslint-disable-next-line react/no-deprecated
		return void ReactDOM.render(<BrowserNotSupportedPage />, documentBody);
	}
	initialization(sessionData);
	hideMainContainer();
	renderComponentIntoDOM(
		<ThemeContainer>
			<Pendo />
			<RoutesContext.Consumer>
				{({ location, matchRoute }) => (
					<StandaloneConfluenceNavigationContainer
						apolloClient={getApolloClient()}
						location={location}
						matchRoute={matchRoute}
					/>
				)}
			</RoutesContext.Consumer>
		</ThemeContainer>,
		'ui-global-sidebar-section',
		true,
	);
});
